import React from "react";
import Card from "react-bootstrap/Card";
import CardGroup from "react-bootstrap/CardGroup";
import BoxData from "../Box";
import CardNav from "../CardNav";
import { BusinessDatatwo } from "../../../../constants/jsonConstant";
import { Col, Container, Row } from "react-bootstrap";
import { images } from "../../../../constants";

const SellVehicleOnline = () => {
  return (
    <div>
      <Row>
        <CardNav Header="Sell Vehicle" />

        <Col lg="12">
          <Card className="shadow-joboprt">
            <BoxData
              Title="Used Vehicle"
              Butonn="Create Shop"
              imgg={images.BuyVehicles}
              url="/usedvehicle-integrate"
              ms="seventeen-element"
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default SellVehicleOnline;
